import { IProperty } from '@app/models/Property'
import { List, Record } from 'immutable'
import { Address, IAddress } from './Address'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'
import { PropertyType } from './enums'
import { GeoJsonPoint } from './GeoJsonPoint'

export interface IAssociatedProperty {
  readonly address: IAddress
  readonly name: string
  readonly owners: List<IAssociatedContact>
  readonly propertyId: string
  readonly propertyTypes: List<PropertyType>
  readonly gps: GeoJsonPoint
}

const AssociatedPropertyRecord = Record({
  address: new Address(),
  name: '',
  owners: List<AssociatedContact>(),
  propertyId: '',
  propertyTypes: List<PropertyType>(),
  gps: new GeoJsonPoint(),
})

export class AssociatedProperty extends AssociatedPropertyRecord {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new AssociatedProperty()
    }

    const { address, owners, gps, ...rest } = initialState
    return new AssociatedProperty({
      address: Address.fromJS(address),
      owners: Array.isArray(owners)
        ? List(
            owners.map((o: IAssociatedContact) => AssociatedContact.fromJS(o)),
          )
        : List<AssociatedContact>(),
      ...rest,
      gps: GeoJsonPoint.fromJS(gps),
    })
  }

  public static fromProperty(property: IProperty): AssociatedProperty {
    return AssociatedProperty.fromJS({
      address: property.address,
      name: property.name,
      owners: property.owners,
      propertyId: property.id,
      propertyTypes: property.propertyTypes,
      gps: property.gps,
    })
  }

  public readonly address: Address
  public readonly name: string
  public readonly owners: List<AssociatedContact>
  public readonly propertyId: string
  public readonly propertyTypes: List<PropertyType>
  public readonly gps: GeoJsonPoint

  constructor(initialState?: Partial<AssociatedProperty>) {
    initialState ? super(initialState) : super()
  }
}
